// Fixed navigation
window.onscroll = function () {
    var navigation = document.getElementById("navigation");
    if (window.scrollY === 0) {
      navigation.classList.remove("scroll-nav");
    } else {
      navigation.classList.add("scroll-nav");
    }
};

// Open and close navigation basket
function toggleBasket() {
  var basket = document.getElementById("basket");
  basket.classList.toggle('open');
}

// Select current nav link 
const pathName = window.location.pathname;

let desktopNavLinks = document.querySelectorAll('.desktop-nav-link');
desktopNavLinks.forEach(link => {
    if ((pathName.replace(/\-/g, "")).includes(link.innerText.toLowerCase().replace(/\s+/g, ""))) {
      link.classList.add('activePage')
    }
})

let mobileNavLinks = document.querySelectorAll('.mobile-nav-link');
mobileNavLinks.forEach(link => {
    if ((pathName.replace(/\-/g, "")).includes(link.innerText.toLowerCase().replace(/\s+/g, ""))) {
      link.classList.add('activePage')
    }
})